export default __webpack_public_path__ + "static/media/sharifcamp.1419b7c4.png";